// extracted by mini-css-extract-plugin
export default {"component":"zciJNS","image":"mhVvfT","rotation":"gBFEgG"};